var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.passage.absolute,staticClass:"word-list-widget u-widget u-flex"},[(_vm.filteredWordList.length > 0)?_c('WordList',{attrs:{"wordList":_vm.filteredWordList}}):_c('EmptyMessage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }